import React from 'react';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import {
  FDPaper, FDStack, FDHeadlineText, FDBox, FDBodyText,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import MetaControl from 'Components/UI/Meta/MetaControl';
import HouseholdInfoSectionSnippets
  from 'Components/ComponentLibrary/Organisms/HouseholdInfoSection/HouseholdInfoSectionSnippets/HouseholdInfoSectionSnippets';
import TransitionsDashboardPageSectionPrimaryActionPicker
  from 'Views/Page/Content/Templates/TransitionsDashboardPage/TransitionsDashboardPage/TransitionsDashboardPageSection/TransitionsDashboardPageSectionPrimaryActionPicker/TransitionsDashboardPageSectionPrimaryActionPicker';
import HouseholdCurrentStates
  from 'Views/Page/Content/Templates/TransitionsDashboardPage/HouseholdCurrentStates/HouseholdCurrentStates';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const metaOverride = buildFacetDesignOverride()
  .nameOverride(['title'], {
    _component: () => FDHeadlineText,
    _customProps: { color: 'textSecondary' },
  }, overrideReadOnly)
  .nameOverride(['subtitle'], {
    _component: () => FDBodyText,
  }, overrideReadOnly)
  .nameOverride(['headlineSnippets', 'bodySnippets'], {
    _component: () => HouseholdInfoSectionSnippets,
  }, overrideReadOnly)
  .nameOverride(['currentStateItems'], {
    _component: () => HouseholdCurrentStates,
  }, overrideReadOnly);

const useStyles = buildUseStyles('TransitionsDashboardPageSectionLayout', () => ({
  card: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    gap: '16px',
  },
}));

const TransitionsDashboardPageSectionLayout = ({ resource }) => {
  const classes = useStyles();

  return (
    <FDPaper appearance={'elevated'} margin={300} padding={500} minWidth={'400px'} height={'400px'} overflow={'hidden'}>
      <div className={classes.card}>
        <FDStack spacing={2} justifyContent={'space-between'} alignItems={'center'}>
          <MetaControl attrName={'title'} metaOverrideSet={metaOverride} resource={resource} />
          <FDBox>
            <MetaControl attrName={'headlineSnippets'} metaOverrideSet={metaOverride} resource={resource} />
          </FDBox>
        </FDStack>
        <FDBox flex={1} overflow={'auto'}>
          <MetaControl attrName={'bodySnippets'} metaOverrideSet={metaOverride} resource={resource} />
          <MetaControl attrName={'currentStateItems'} metaOverrideSet={metaOverride} resource={resource} />
        </FDBox>
        <FDStack justifyContent={'flex-start'}>
          <TransitionsDashboardPageSectionPrimaryActionPicker resource={resource} />
        </FDStack>
      </div>
    </FDPaper>
  );
};

TransitionsDashboardPageSectionLayout.defaultProps = {};

TransitionsDashboardPageSectionLayout.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default TransitionsDashboardPageSectionLayout;
